import { Accordion } from "./Accordion";

new Accordion().Init();
